import { render, staticRenderFns } from "./create-sim.vue?vue&type=template&id=ec33016a&"
import script from "./create-sim.vue?vue&type=script&lang=js&"
export * from "./create-sim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports